import type { ValueOf } from './ValueOf';

export const ApprovalUserType = {
  REQUESTER: 'REQUESTER',
  APPROVER: 'APPROVER',
  NON_PARTICIPANT: 'NON_PARTICIPANT',
} as const;

export type ApprovalUserType = ValueOf<typeof ApprovalUserType>;
